import { Box, Typography } from '@mui/material';
import React from 'react';
import UserAvatar, { getUserInitials } from './UserAvatar';
import { useAuthContext } from '@/contexts/AuthContext';

export { getUserInitials };

const UserBadge: React.FC<{ isHorizontal?: boolean }> = ({
 isHorizontal = false,
}) => {
 const { selfUser } = useAuthContext();

 return (
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexDirection: isHorizontal ? 'row' : 'column',
    textAlign: isHorizontal ? 'left' : 'center',
   }}
  >
   <UserAvatar user={selfUser} size={64} />
   <Box>
    <Typography
     sx={{
      fontSize: '18px',
      fontWeight: 500,
      color: (th) => th.palette.kemek.darkestGray,
     }}
    >
     {selfUser?.Name} {selfUser?.Surname}
    </Typography>
    <Typography
     sx={{
      fontSize: '14px',
      color: (th) => th.palette.kemek.darkGray,
     }}
    >
     {selfUser?.AuthEmail}
    </Typography>
   </Box>
  </Box>
 );
};

export default UserBadge;
